import { render } from "./PickupManage.vue?vue&type=template&id=08afe120"
import script from "./PickupManage.vue?vue&type=script&lang=js"
export * from "./PickupManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__